export default "__VITE_ASSET__02d05786__"